import { gameSelectors, gameActions, loadingActions, levelSelectors } from '~/store';
import { UI_FETCHING_NETWORK_REQUEST } from '~/store/ui/actionTypes';
import { LOADING_TYPES, LEVELS_TO_UNLOCK_FEATURES } from '~/lib/constants'
// ---- external imports ----

import * as types from './actionTypes';
import { resetTimer } from '../turn/utlis';
import GameService from '~/services/game.service';
import { removeTutorialStep } from '~/lib/financialTutorialStorage';
// ---- local imports ----


function clearFinancialStatementTutorialStepsForLevel(gameUserId, level) {
	if (level === LEVELS_TO_UNLOCK_FEATURES.FINANCIAL_STATEMENTS_EDIT) {
		removeTutorialStep(gameUserId, 'incomeStatement');
		removeTutorialStep(gameUserId, 'balanceSheet');
	}
	if (level === LEVELS_TO_UNLOCK_FEATURES.FINANCIAL_RATIOS_EDIT) {
		removeTutorialStep(gameUserId, 'financialRatios');
	}
}

function load(checkpoint) {
	return { type: types.CHECKPOINT_LOADED, checkpoint };
}

function save() {
	return async (dispatch, getState) => {
		dispatch(loadingActions.start(UI_FETCHING_NETWORK_REQUEST, LOADING_TYPES.CURSOR));
		await GameService.saveCheckpoint(
			gameSelectors.getGameId(getState()),
		);
		await dispatch(loadingActions.end(UI_FETCHING_NETWORK_REQUEST));
	};
}

function saveForCompletedLevel() {
	return save(false);
}

function reload() {
	return async (dispatch, getState) => {
		dispatch(loadingActions.start(types.CHECKPOINT_RELOAD));
		const gameUserId = gameSelectors.getGameId(getState());
		resetTimer();

		const result = await GameService.reloadCheckpoint(gameUserId);

		if (!result.isSuccess) {
			dispatch(loadingActions.endAfterNetworkFaliures());
			return;
		}

		clearFinancialStatementTutorialStepsForLevel(
			gameSelectors.getGameId(getState()),
			levelSelectors.getLevelNumber(getState()),
		);

		dispatch(gameActions.load(gameUserId, true));
		dispatch({ type: types.CHECKPOINT_RELOAD });
		dispatch(loadingActions.end(types.CHECKPOINT_RELOAD));
	};
}

function reloaded() {
	return { type: types.CHECKPOINT_RELOADED };
}

export {
	load,
	save,
	saveForCompletedLevel,
	reload,
	reloaded
};
